import ParentRoute from './PatientRoute'
export default ParentRoute
